import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Check if role has admin-level privileges (admin or super_admin) */
export function isAdminLevel(role) {
  return role === 'admin' || role === 'super_admin';
}

/** Check if role is specifically super_admin */
export function isSuperAdmin(role) {
  return role === 'super_admin';
}

export const PAYMENT_MODE_OPTIONS = [
  { value: 'advance', label: 'Advance' },
  { value: 'cash', label: 'Cash' },
  { value: 'pdc_cheque', label: 'PDC Cheque' },
  { value: 'credit', label: 'Credit' },
];

const PAYMENT_MODE_LABELS = Object.fromEntries(PAYMENT_MODE_OPTIONS.map(o => [o.value, o.label]));

export function formatPaymentMode(value) {
  if (!value) return '';
  return PAYMENT_MODE_LABELS[value] || value.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}


/** Title Case a colour/string: "light blue" → "Light Blue", "OLIVE" → "Olive" */
export function titleCaseColor(str) {
  if (!str) return '';
  return str.trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
}
